import axios from 'axios';
import type { AxiosRequestConfig } from 'axios';
import BaspInterceptor from '@/apis/interceptors/BaspInterceptor';
import DefaultInterceptor from '@/apis/interceptors/DefaultInterceptor';
import LoginInterceptor from '@/apis/interceptors/LoginInterceptor';
import { useSettingsStore } from '@/layouts/sfapp';

/**
 * 后端接口响应格式
 */
export interface HttpResponse<T = unknown> {
  success: boolean;
  obj: T;
  errorCode: string;
  errorMessage: string;
  respCode?: string;
}

const axiosInstance = axios.create({
  timeout: 1000 * 60,
  responseType: 'json',
});

// 请求拦截器
axiosInstance.interceptors.request.use((config) => {
  const { settings } = useSettingsStore();
  if (settings.api.baseURL) {
    config.baseURL = settings.api.baseURL;
  }
  return config;
});
axiosInstance.interceptors.request.use(...BaspInterceptor.request);
axiosInstance.interceptors.request.use(...LoginInterceptor.request);
axiosInstance.interceptors.request.use(...DefaultInterceptor.request);

// 响应拦截器
axiosInstance.interceptors.response.use(...BaspInterceptor.response);
axiosInstance.interceptors.response.use(...LoginInterceptor.response);
axiosInstance.interceptors.response.use(...DefaultInterceptor.response);

// 封装axios请求，充分利用类型检查与提示
const request = async <T = any>(config: AxiosRequestConfig): Promise<HttpResponse<T>> => {
  const { data } = await axiosInstance.request<HttpResponse<T>>(config);
  return data;
};

export { request, axiosInstance };
